import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { MAIN_MENU_TRANSLATION_KEY } from "../../../constants";
export default /*#__PURE__*/_defineProperty({}, MAIN_MENU_TRANSLATION_KEY, {
  CTA_INPUT_PHONE: 'Descobrir',
  PHONE_REQUIRED: 'Numero obrigatório',
  MAIN_MENU_PHONE_INPUT_THANKS_TITLE: 'Obrigado!',
  MAIN_MENU_PHONE_INPUT_THANKS: 'Estaremos falando com você em breve :)',
  MAIN_MENU_PHONE_INPUT_END: 'Finalizar'
});